import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ParticipantsSearchState = {
    query: string;
};

const initialState: ParticipantsSearchState = {
    query: '',
};

const participantsSearchSlice = createSlice({
    name: 'participantsSearch',
    initialState,
    reducers: {
        updateQuery(state: ParticipantsSearchState, action: PayloadAction<string>) {
            state.query = action.payload;
        },
    },
});
export const { updateQuery } = participantsSearchSlice.actions;
export const participantsSearchReducer = participantsSearchSlice.reducer;
